import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DEVICE_UUID_GENERATOR, DeviceUuidGenerator } from 'src/app/utils/cargo-driver-check-in-service/const';

@Injectable({
    providedIn: 'root'
})
export class DeviceUuidService {

    constructor(
        @Inject(DEVICE_UUID_GENERATOR) private deviceUuidGenerator: DeviceUuidGenerator
    ) { }
    
    getDeviceUUID(): Observable<string> {
        return this.deviceUuidGenerator();
    }

}
